module.exports = __webpack_public_path__ + "static/fonts/iconfont.3ee90e9.ttf";